export const LANDING = '/';
export const TRIP = '/trip';
export const ADMIN = '/admin';
